import { getIn } from 'formik';
import type { FormikTouchedErrorsForm } from './formikTypes';

export function fieldErrorElementId(fieldName: string): string {
  return `${fieldName}-errorMsg`;
}

export function joinClassNames(
  ...parts: Array<string | false | null | undefined>
): string {
  return parts.filter(Boolean).join(' ');
}

export function getFieldErrorState(
  form: FormikTouchedErrorsForm,
  fieldName: string
) {
  const touched = getIn(form.touched, fieldName);
  const errors = getIn(form.errors, fieldName);
  const isError = Boolean(touched && errors);
  const errorElementId = fieldErrorElementId(fieldName);
  return {
    isError,
    errorElementId,
    ariaDescribedBy: isError ? errorElementId : undefined,
  };
}
